export default "__VITE_ASSET__BnysB97k__"